var $ = require('jquery');
var slick = require('@accessible360/accessible-slick');

module.exports = {
	init: function () {
		var slider = $('.slider .slider-items');
		if (slider.length > 0) {
			for (var i = 0; i < slider.length; i++) {
				var $currentSlider = $(slider[i]);
				var $sliderContainer = $currentSlider.closest('.slider');

				// Determine slides to show based on grid class
				var slidesToShow = 4; // Default
				if ($sliderContainer.hasClass('grid-3')) {
					slidesToShow = 3;
				} else if ($sliderContainer.hasClass('grid-4')) {
					slidesToShow = 4;
				}

				// Init slider with responsive settings
				$currentSlider.slick({
					dots: true,
					infinite: false,
					arrows: true,
					speed: 300,
					slidesToShow: slidesToShow,
					slidesToScroll: 1,
					draggable: true,
					swipeToSlide: true,
					touchThreshold: 10,
					appendDots: $sliderContainer.parent().find('.slick-dots-wrapper'),
					prevArrow: $sliderContainer.parent().find('.slick-prev'),
					nextArrow: $sliderContainer.parent().find('.slick-next'),
					//appendArrows: $sliderContainer.find('.slider-controls'),
					responsive: [
						{
							breakpoint: 1260, // $laptop
							settings: {
								slidesToShow: slidesToShow === 4 ? 3 : slidesToShow,
								slidesToScroll: 1,
							},
						},
						{
							breakpoint: 768, // $tablet
							settings: {
								slidesToShow: 2,
								slidesToScroll: 1,
							},
						},
						{
							breakpoint: 640, // $mobile-lg
							settings: {
								slidesToShow: 1,
								slidesToScroll: 1,
							},
						},
					],
				});
			}
		}
	},
};
